import React from 'react'
import robo from '../img/robodiner.png'
import rms from '../img/rms.jpeg'

const Sponsers = () => {

    const openLink=(link)=>{
        window.scrollTo(0,0);
        window.open(link);
    }
    return (
        <>
          <div className="sponsers">
                 <div className="sponsers__banner"></div>
             <div className="sponsers__wrapper">
                <div className="sponsers__content">
                    <h1> Fest <span>Sponsors</span></h1>
                    <div className="sponsers__sponsers">
                        <img src="" alt="" />
                      <img onClick={()=>openLink('https://instagram.com/rmsgroups?utm_medium=copy_link')} src={rms} alt="rms" />
                      <img src="" alt="" />
                      {/* <img onClick={()=>openLink('https://instagram.com/therobodiner?utm_medium=copy_link')} src={robo} alt="" /> */}
                    </div>
                    </div>  
                </div>
            </div>  
        </>
    )
}

export default Sponsers
